module.exports = __webpack_public_path__ + "img/favicon.5d9c5794.png";